import { MrAccordion } from '@mrhenry/wp--mr-interactive';

customElements.define( 'mr-accordion', MrAccordion );
